'use strict';

module.exports = require('./Switch');


/*****************
 ** WEBPACK FOOTER
 ** ./~/._rc-switch@1.4.3@rc-switch/lib/index.js
 ** module id = 620
 ** module chunks = 0 1
 **/